<template>
  <Picker
    ref="emojiPicker"
    :auto-focus="true"
    :data="emojiIndex"
    :native="true"
    :skin="selectedSkin"
    :title="''"
    :show-categories="false"
    :show-skin-tones="false"
    :show-preview="false"
    :per-line="11"
    @select="showEmoji"
    @skin-change="setSkin"
  />
</template>

<script>
import { Picker } from 'emoji-mart-vue-fast/src';

// Import default CSS
import 'emoji-mart-vue-fast/css/emoji-mart.css';

export default {
  name: 'EmojiPicker',

  components: {
    Picker,
  },

  props: {
    emojiIndex: {
      type: Object,
      required: true,
    },
  },

  emits: ['addEmoji'],

  data() {
    return {
      selectedSkin: 1,
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.$refs.emojiPicker.$refs?.search?.$el?.firstChild?.focus?.();
    });
  },

  methods: {
    showEmoji(emoji) {
      this.$emit('addEmoji', emoji);
    },
    setSkin(skin) {
      this.selectedSkin = skin;
    },
  },
};
</script>
